import { render } from "./VerifyQuestion.vue?vue&type=template&id=2d3f406e"
import script from "./VerifyQuestion.vue?vue&type=script&lang=js"
export * from "./VerifyQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__